import RequestAbstract from "../abstract";

export default class MerchantCategory extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/merchant-category";
    }
}
